import { Card, Heading3, P, Strong, TextLink } from '@ovotech/nebula';
import React from 'react';
import { OVO_QUOTE_AND_SWITCH } from '@/src/constants/endpoints';
import { SkeletonCard } from '@/src/pages/Home/components/SkeletonCard';
import { ErrorSection } from '@/src/components';
import { MOVE_OUT_IN_PROGRESS_ERROR } from '@/src/constants/error-section-ids';
import { ActionCentreBanner } from '@/src/components/ActionCentre/Banners/banners';
import { Banner } from '@/src/components/ActionCentre/Banners/Banner';
import { useMoveOutData } from '@/src/components/ActionCentre/Banners/MoveOut/useMoveOutData';

export const MoveOutComplete: ActionCentreBanner = () => {
  const { isLoading, isError, address, moveOutDate } = useMoveOutData();

  if (isLoading) {
    return <SkeletonCard testId="loader" />;
  }

  if (isError) {
    return (
      <Card>
        <ErrorSection alertLevel="error" id={MOVE_OUT_IN_PROGRESS_ERROR} />
      </Card>
    );
  }

  return (
    <Banner icon="loss">
      <Heading3 as="h2">Your move out is complete</Heading3>
      <P>
        You told us that you moved out of{' '}
        <Strong>{address ? address : 'unknown address'}</Strong> on the{' '}
        {moveOutDate}. Your energy contract ended on that date. We've created a
        final statement which is available below.
      </P>
      <P>
        If you’d like your new home to be supplied by OVO Energy, then{' '}
        <TextLink href={OVO_QUOTE_AND_SWITCH} opensInNewWindow>
          enter your new address to get a quote.
        </TextLink>
      </P>
    </Banner>
  );
};
